import {styled} from "@reside/ui";
import {BackdropSpinner} from "../spinner";

export const ExportAuditDataSpinner = styled(BackdropSpinner)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
`;
